import type { ReactNode } from "react";
import { ThemeToggle } from "@/ui/ThemeToggle";
import { Avatar, TopNav } from "./nav";
import { Bell } from "./Bell";

/** Шапка и контейнер страницы по A0/S1: sticky-шапка, навигация разделов,
 *  справа — когорта и ментор, аватар, переключатель темы. */
export function Shell({
  screen,
  user,
  meta,
  nav = false,
  wide = false,
  children,
}: {
  screen?: string;
  user?: { name: string; role: string };
  /** Правый текст шапки: «когорта ML-осень-2026 · ментор Никита». */
  meta?: string;
  nav?: boolean;
  /** Без ограничения ширины и отступов контейнера (карта, конструктор). */
  wide?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-bg text-[14px] leading-[1.5] text-ink">
      <header className="sticky top-0 z-20 flex items-center gap-4 border-b border-bd bg-bg px-4 py-3.5 md:px-8">
        <a href="/" className="flex items-center gap-2.5 text-ink no-underline">
          <img src="/logo.png" alt="" width={26} height={26} className="rounded-full" />
          <span className="font-mono text-[13px] font-semibold tracking-[.02em]">awakening</span>
        </a>
        {nav && <TopNav />}
        {screen && !nav && <span className="font-mono text-[11px] uppercase tracking-[.06em] text-mut">{screen}</span>}
        <span className="flex-1" />
        {meta && <span className="hidden font-mono text-[11px] text-mut md:inline">{meta}</span>}
        {user && <Bell />}
        {user && (
          <span className="flex items-center gap-2 font-mono text-[11px] text-mut" data-testid="user">
            <span className="hidden md:inline">
              {user.name} · {user.role}
            </span>
            <Avatar name={user.name} />
          </span>
        )}
        <ThemeToggle />
      </header>
      <main className={wide ? "" : "mx-auto flex max-w-[1320px] flex-col gap-8 px-4 pb-24 pt-6 md:gap-11 md:px-8 md:pt-8"}>{children}</main>
    </div>
  );
}

export const ROLE_LABEL: Record<string, string> = {
  student: "студент",
  mentor: "ментор",
  admin: "админ",
  owner: "владелец",
};
